export enum PendingEventType {
  CustomEvent = 1,
  OnetimeLink = 2,
  Poll = 3,
  Request = 4,
}
